<i18n src="@/locales/models/container_final_quality.yml" lang="yaml"></i18n>

<template>
  <span :class="guiStatus">
    {{ prepend_label }}
    {{ statusLabel }}
  </span>
</template>

<script>
import ContainerFinalQualityMixin from "@/components/views/mixins/models/container_final_quality.js";

export default {
  name: "AEProductionQueryContainerExportContainerStatus",
  mixins: [ContainerFinalQualityMixin],
  props: ["status_id", "prepend_label"],
  computed: {
    guiStatus() {
      let status_class =
        "inline-flex items-center px-2 py-0.5 rounded text-sm font-medium";
      let color = this.qualityStatusColor(this.status_id);
      if (color) status_class += ` bg-${color}-100 text-${color}-800`;
      return status_class;
    },
    statusLabel() {
      let key = this.qualityStatusKey(this.status_id);
      return key
        ? this.$t(`model.container_final_quality.statuses.${key}`)
        : "";
    }
  }
};
</script>
